import './styles.css';
import './i18n.js';

const navToggle=document.querySelector('[data-nav-toggle]');
const nav=document.querySelector('[data-nav]');

if(navToggle&&nav){
  navToggle.addEventListener('click',()=>{
    const open=navToggle.getAttribute('aria-expanded')!=='true';
    navToggle.setAttribute('aria-expanded',String(open));
    nav.classList.toggle('is-open',open);
  });

  nav.addEventListener('click',(event)=>{
    if(!event.target.closest('a'))return;
    navToggle.setAttribute('aria-expanded','false');
    nav.classList.remove('is-open');
  });
}

const revealObserver=new IntersectionObserver((entries)=>{
  entries.forEach((entry)=>{
    if(!entry.isIntersecting)return;
    entry.target.classList.add('is-visible');
    revealObserver.unobserve(entry.target);
  });
},{threshold:0.08});

document.querySelectorAll('[data-reveal]').forEach((element)=>revealObserver.observe(element));
